<template>
  <div
    v-if="status"
    :class="getStatusClass">
    <sc-icon
      :icon="getStatusIcon"
      size="is-small" />
       {{ getStatusLabel }}
  </div>
</template>
<script>
  import { ScIcon } from '@intelipost-js/secure-components';
  import LocalizedStateEnum from '../enums/localizedStatus.enum';

  export default {
    name: 'sc-localized-status',
    props: {
      status: {
        type: String,
        required: true,
      },
    },
    computed: {
      getStatusClass() {
        return (this.status && LocalizedStateEnum[this.status]) ? LocalizedStateEnum[this.status].class : '';
      },
      getStatusIcon() {
        return (this.status && LocalizedStateEnum[this.status]) ? LocalizedStateEnum[this.status].icon : '';
      },
      getStatusLabel() {
        return (this.status && LocalizedStateEnum[this.status]) ? LocalizedStateEnum[this.status].label : '';
      },
    },
    components: {
      ScIcon,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-psl/features/list/components/ScLocalizedStatus.vue